export enum MainCategories {
  WASTE_PROFILE_INQUIRY = 'Waste Profile Inquiry',
  GENERATOR_INQUIRY = 'Generator Inquiry',
  ACCOUNT_INQUIRY = 'Account Inquiry',
  TECHNICAL_SUPPORT = 'Technical Support',
  MISCELLANEOUS = 'Miscellaneous',
}

export interface CategoryControl {
  label?: string;
  control: string;
  type?: string;
  validators?: boolean;
  defaultValues?: any;
}

export enum SubCategories {
  PROFILE_ACCESS_REQUEST = 'Profile Access Request(Profile Segmenting)',
  REQUEST_MISSING_PROFILES = 'Request Missing Profiles',
  QUESTIONS_ABOUT_SPECIFIC_WP = 'Questions About Specific Waste Profiles',
  WASTE_PROFILE_UPDATE = 'Waste Profile Update',
  ISSUES_ATTACHING_DOCUMENTS = 'Issues Attaching Documents',
  GENERATOR_UPDATES = 'Generator Updates',
  LOGIN_ISSUES = 'Login Issues',
  VERIFICATION_EMAIL = 'Verification Email Not Received',
  FORGOT_PASSWORD_EMAIL = 'Forgot Password Email Not Recived',
  EMAIL_INCORRECT = 'Name or Email Incorrect',
  MISSING_FUNCTIONALITY = 'Missing Functionality (Permissions/Role Update)',
  CANT_EDIT_WP = 'Can`t Edit Waste Profile Information',
  NOT_RECEIVING_EMAILS = 'Not Receiving Emails from Portal',
  LOGGED_IN_USER_CANNOT_SIGN = 'Logged in User Cannot Sign Waste Profile',
  GENERATOR_CONTACT_CONNOT_SIGN = 'Generator Contact Cannot Sign Waste Profile',
  INQUIRING_ABOUT_PAYMENTS = 'Inquiring about Payment(Requesting Invoice, or Making Payment) ',
  NEED_HELP = 'Need help/What Do I Do?',
  SPECIFIC_SERVICE = 'Inquiring About a Specific Service',
}
export interface Category {
  [key: string]: {
    [key: string]: CategoryControl[];
  };
}

export const Categories: Category = {
  [MainCategories.WASTE_PROFILE_INQUIRY]: {
    [SubCategories.PROFILE_ACCESS_REQUEST]: [
      {
        label: 'Waste Profile Number',
        control: 'wasteProfileNumber',
        type: 'text',
        validators: true,
      },
      {
        type: 'and',
        control: undefined,
      },
      {
        label: 'Site Address',
        control: 'generatorSiteaddress',
        type: 'siteAddress',
        validators: false,
        defaultValues: {
          country: 'US',
        },
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.REQUEST_MISSING_PROFILES]: [
      {
        label: 'Waste Profile Number',
        control: 'wasteProfileNumber',
        type: 'text',
        validators: true,
      },
      {
        type: 'and',
        control: undefined,
      },
      {
        label: 'Waste Stream Name',
        control: 'wasteStreamName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Site Address',
        control: 'generatorSiteaddress',
        type: 'siteAddress',
        validators: false,
        defaultValues: {
          country: 'US',
        },
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.QUESTIONS_ABOUT_SPECIFIC_WP]: [
      {
        label: 'Waste Profile Number',
        control: 'wasteProfileNumber',
        type: 'text',
        validators: true,
      },
      {
        type: 'and',
        control: undefined,
      },
      {
        label: 'Waste Stream Name',
        control: 'wasteStreamName',
        type: 'text',
        validators: false,
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.WASTE_PROFILE_UPDATE]: [
      {
        label: 'Waste Profile Number',
        control: 'wasteProfileNumber',
        type: 'text',
        validators: true,
      },
      {
        type: 'and',
        control: undefined,
      },
      {
        label: 'Site Address',
        control: 'generatorSiteaddress',
        type: 'siteAddress',
        validators: false,
        defaultValues: {
          country: 'US',
        },
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.ISSUES_ATTACHING_DOCUMENTS]: [
      {
        label: 'Waste Profile Number',
        control: 'wasteProfileNumber',
        type: 'text',
        validators: true,
      },
      {
        type: 'and',
        control: undefined,
      },
      {
        label: 'Waste Stream Name',
        control: 'wasteStreamName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Site Address',
        control: 'generatorSiteaddress',
        type: 'siteAddress',
        validators: false,
        defaultValues: {
          country: 'US',
        },
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
  },
  [MainCategories.GENERATOR_INQUIRY]: {
    [SubCategories.GENERATOR_UPDATES]: [
      {
        label: 'Generator Name',
        control: 'generatorName',
        type: 'text',
        validators: true,
      },
      {
        type: 'and',
        control: undefined,
      },
      {
        label: 'Site Address',
        control: 'generatorSiteaddress',
        type: 'siteAddress',
        validators: false,
        defaultValues: {
          country: 'US',
        },
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
  },
  [MainCategories.ACCOUNT_INQUIRY]: {
    [SubCategories.LOGIN_ISSUES]: [
      {
        label: 'First Name',
        control: 'firstName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Last Name',
        control: 'lastName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Email Address',
        control: 'emailAddress',
        type: 'text',
        validators: true,
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.VERIFICATION_EMAIL]: [
      {
        label: 'First Name',
        control: 'firstName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Last Name',
        control: 'lastName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Email Address',
        control: 'emailAddress',
        type: 'text',
        validators: true,
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.FORGOT_PASSWORD_EMAIL]: [
      {
        label: 'First Name',
        control: 'firstName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Last Name',
        control: 'lastName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Email Address',
        control: 'emailAddress',
        type: 'text',
        validators: true,
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.EMAIL_INCORRECT]: [
      {
        label: 'First Name',
        control: 'firstName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Last Name',
        control: 'lastName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Email Address',
        control: 'emailAddress',
        type: 'text',
        validators: true,
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.MISSING_FUNCTIONALITY]: [
      {
        label: 'First Name',
        control: 'firstName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Last Name',
        control: 'lastName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Email Address',
        control: 'emailAddress',
        type: 'text',
        validators: true,
      },
      {
        label: 'What features do you need access to ?',
        control: 'featureAccess',
        type: 'featureAccess',
        validators: true,
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
  },
  [MainCategories.TECHNICAL_SUPPORT]: {
    [SubCategories.CANT_EDIT_WP]: [
      {
        label: 'First Name',
        control: 'firstName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Last Name',
        control: 'lastName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Email Address',
        control: 'emailAddress',
        type: 'text',
        validators: true,
      },
      {
        label: 'Waste Profile Number',
        control: 'wasteProfileNumber',
        type: 'text',
        validators: true,
      },
      {
        label: 'Waste Stream Name',
        control: 'wasteStreamName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.NOT_RECEIVING_EMAILS]: [
      {
        label: 'First Name',
        control: 'firstName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Last Name',
        control: 'lastName',
        type: 'text',
        validators: true,
      },
      {
        label: 'Email Address',
        control: 'emailAddress',
        type: 'text',
        validators: true,
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.LOGGED_IN_USER_CANNOT_SIGN]: [
      {
        label: 'Waste Profile Number',
        control: 'wasteProfileNumber',
        type: 'text',
        validators: true,
      },
      {
        type: 'and',
        control: undefined,
      },
      {
        label: 'Waste Stream Name',
        control: 'wasteStreamName',
        type: 'text',
        validators: false,
      },
      {
        label: 'Site Address',
        control: 'generatorSiteaddress',
        type: 'siteAddress',
        validators: false,
        defaultValues: {
          country: 'US',
        },
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
    [SubCategories.GENERATOR_CONTACT_CONNOT_SIGN]: [
      {
        label: 'Waste Profile Number',
        control: 'wasteProfileNumber',
        type: 'text',
        validators: true,
      },
      {
        type: 'and',
        control: undefined,
      },
      {
        label: 'Waste Stream Name',
        control: 'wasteStreamName',
        type: 'text',
        validators: false,
      },
      {
        label: 'Site Address',
        control: 'generatorSiteaddress',
        type: 'siteAddress',
        validators: false,
        defaultValues: {
          country: 'US',
        },
      },
      {
        label: 'Additional Information:',
        control: 'additionalInformation',
        type: 'additionalInfo',
        validators: false,
      },
    ],
  },
  [MainCategories.MISCELLANEOUS]: {
    [SubCategories.INQUIRING_ABOUT_PAYMENTS]: [
      {
        type: 'payments',
        control: undefined,
      },
    ],
    [SubCategories.NEED_HELP]: [
      {
        label: 'What is your inquiry regarding?',
        control: 'inquiry',
        type: 'inquiry',
        validators: true,
      },
    ],
    [SubCategories.SPECIFIC_SERVICE]: [
      {
        label: 'What is your inquiry regarding?',
        control: 'inquiry',
        type: 'inquiry',
        validators: true,
      },
    ],
  },
};
